import {
  SET_EMAIL_FOR_SHARED_AUTH,
  SET_ROLES_FOR_SHARED_AUTH,
  SET_PERMISSIONS_FOR_SHARED_AUTH,
  SET_DISPLAY_NAME_FOR_SHARED_AUTH,
  SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH,
  SET_DOB_FOR_SHARED_AUTH,
  SET_GROUP_NAME_FOR_SHARED_AUTH,
  SET_IS_ALLOWED_FOR_SHARED_AUTH,
  SET_IS_VALID_TYPE_FOR_SHARED_AUTH,
  SET_MAINTENANCE_MESSAGE,
  SET_LOGIN_ATTEMPTED
} from './constants';

export const initialState = {
  email: null,
  displayName: null,
  roles: [],
  permissions: [],
  dob: null,
  profileIsValid: false,
  profileIsConfirmed: false,
  validationMessage: '',
  groupName: null,
  loginAttempted: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_EMAIL_FOR_SHARED_AUTH:
      return {
        ...state,
        email: payload || null
      };
    case SET_ROLES_FOR_SHARED_AUTH:
      return {
        ...state,
        roles: payload || []
      };
    case SET_PERMISSIONS_FOR_SHARED_AUTH:
      return {
        ...state,
        permissions: payload || []
      };
    case SET_DISPLAY_NAME_FOR_SHARED_AUTH: {
      let nameToDisplay = null;

      if (payload == null) {
        nameToDisplay = null;
      } else {
        if ((payload.firstName || payload.lastName) && payload.firstName == payload.lastName) {
          nameToDisplay = `${payload.firstName || ''}`;
        } else if (payload.firstName || payload.lastName) {
          nameToDisplay = `${payload.firstName || ''} ${payload.lastName || ''}`;
        } else {
          nameToDisplay = payload.email;
        }
      }

      return {
        ...state,
        displayName: nameToDisplay
      };
    }
    case SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH: {
      let profileIsValid = false;
      let profileIsConfirmed = false;
      let profileIsWorking = false;
      let validationMessage = '';

      if (payload != null) {
        profileIsValid = payload.profileIsValid;
        profileIsConfirmed = payload.profileIsConfirmed;
        profileIsWorking = true;
        validationMessage = payload.validationMessage;
      }

      return {
        ...state,
        profileIsValid,
        profileIsConfirmed,
        profileIsWorking,
        validationMessage
      };
    }
    case SET_DOB_FOR_SHARED_AUTH:
      return {
        ...state,
        dob: payload || null
      };

    case SET_GROUP_NAME_FOR_SHARED_AUTH:
      return {
        ...state,
        groupName: payload || null
      };

    case SET_IS_ALLOWED_FOR_SHARED_AUTH:
      return {
        ...state,
        isAllowed: payload || false
      };      

    case SET_IS_VALID_TYPE_FOR_SHARED_AUTH:
      return {
        ...state,
        isValidType: payload || false
      };

    case SET_MAINTENANCE_MESSAGE:
      return {
        ...state,
        maintenanceMessage: payload
      };
    case SET_LOGIN_ATTEMPTED:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/shared/auth/reducer.js